import {
  COLUMN_ITEM_SIZE_BIG,
  COLUMN_ITEM_SIZE_SMALL
} from 'components/ColumnItem/constants'
import ContentBox from 'components/ContentBox'
import Hoverable from 'components/Hoverable'
import { View } from 'components/View'
import React from 'react'
import getStyleComponentUtil from 'modules/component/utils/get-style'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'

class ColumnItem extends React.Component {
  render () {
    return (
      <Hoverable>
        <article>
          <ContentBox
            p={0}
            style={getStyleComponentUtil({
              width: this.props.isSmallScreen || this.props.isSmall
                ? COLUMN_ITEM_SIZE_SMALL
                : COLUMN_ITEM_SIZE_BIG,
              maxWidth: '100%',
              opacity: this.props.isTranslucent ? '0.5' : undefined,
              backgroundColor: 'inherit'
            }, this.props.style)}
          >
            <View>
              {this.props.children}
            </View>
          </ContentBox>
        </article>
      </Hoverable>
    )
  }
}

const select = () => createSelector(
  isSmallScreenViewportSelect,
  (isSmallScreen) => ({
    isSmallScreen
  })
)

export default connect(select)(ColumnItem)
